/*
 * Exports
 */
export { default } from './components/DigitalDurations.component';



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-durations/index.js